export default __webpack_public_path__ + "static/media/refer-icon.ad1c20d9.png";